module.exports = __webpack_public_path__ + "img/32shelf.5bec9ef6.png";